// extracted by mini-css-extract-plugin
export var circle = "style-module--circle--aM1q-";
export var container = "style-module--container--CLTQg";
export var divider = "style-module--divider--lPDQj";
export var gadgetPosition = "style-module--gadgetPosition--3I+77";
export var header = "style-module--header--r0OfE";
export var imageWrapper = "style-module--imageWrapper--Rjjtn";
export var line = "style-module--line--MsgmN";
export var linkedin = "style-module--linkedin--L3krs";
export var name = "style-module--name--HA-GM";
export var root = "style-module--root--CwYHw";
export var title = "style-module--title--GatCK";
export var workshop = "style-module--workshop--iOrvA";
export var workshopTitle = "style-module--workshopTitle--QdLkW";